module.exports = __webpack_public_path__ + "img/category02.74444a6c.png";